<template>
    <footer>
        <div class="constrain bc">
            <div class="get-started flex flex-align">
                <h1 class="ff">Ready to get started?</h1>
                <router-link :to="{name: 'register'}" class="button white">Get API Keys</router-link>
                <router-link :to="{name: 'support'}" class="button white">Contact Sales</router-link>
            </div>
            <nav class="flex flex-align">
                <div class="text">&copy; 2020 Edlink</div>
                <!-- <router-link class="destination" to="/help">Help</router-link> -->
                <div class="ff"></div>
                <a class="social-option twitter" href="" alt="Twitter">Twitter</a>
                <a class="social-option youtube" href="" alt="Youtube">Youtube</a>
            </nav>
        </div>
    </footer>
</template>

<script>
    export default {
        name: 'Footer'
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";
    @import "~@/assets/less/mixins";

    footer
    {
        background: @black;
    }

    .wordmark
    {
        font-size: 18px;
        font-weight: 500;
        color: @white;
        letter-spacing: -0.03rem;
        height: 50px;
        line-height: 50px;
        display: block;
        padding-left: 40px;
        background: url('~@/assets/rings-white.svg') 0 11px no-repeat;
        background-size: 31px auto;
    }

    .get-started
    {
        padding: 80px 0;

        h1
        {
            color: @f;
            font-size: 32px;
            letter-spacing: 0;
        }

        .button
        {
            margin-left: 20px;
        }
    }

    nav
    {
        border-top: 1px solid #666;
        padding: 30px 0;
    }

    .destination, .text
    {
        color: @f;
        display: block;
        white-space: nowrap;
        margin: 0 30px 0 0;
        font-weight: 500;
        font-size: 13px;
        transition: opacity ease 0.2s;
    }

    a.destination
    {
        &:hover, &:active
        {
            opacity: 0.7;
        }
    }

    .social-option
    {
        width: 27px;
        height: 27px;
        display: block;
        margin-left: 10px;
        cursor: pointer;
        background: @f;
        border-radius: 50%;
        text-indent: -9999px;
        color: transparent;
        transition: opacity ease 0.2s;

        &:hover, &:active
        {
            opacity: 0.7;
        }

        &.twitter
        {
            background: url('~@/assets/icons/black/twitter.svg') 6px 7px no-repeat @f;
            background-size: 16px auto;
        }

        &.youtube
        {
            background: url('~@/assets/icons/black/youtube.svg') 6px 5px no-repeat @f;
            background-size: auto 16px;
        }
    }
</style>
